import { render, staticRenderFns } from "./CourseModuleClassesNav.vue?vue&type=template&id=13e6efa8&scoped=true"
import script from "./CourseModuleClassesNav.vue?vue&type=script&lang=js"
export * from "./CourseModuleClassesNav.vue?vue&type=script&lang=js"
import style0 from "./CourseModuleClassesNav.vue?vue&type=style&index=0&id=13e6efa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e6efa8",
  null
  
)

export default component.exports